import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './relation-customer.reducer';

export const RelationCustomer = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const relationCustomerList = useAppSelector(state => state.relationCustomer.entities);
  const loading = useAppSelector(state => state.relationCustomer.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="relation-customer-heading" data-cy="RelationCustomerHeading">
        <Translate contentKey="crawlerBackendApp.relationCustomer.home.title">Relation Customers</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.relationCustomer.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/relation-customer/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.relationCustomer.home.createLabel">
              Create new Relation Customer
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {relationCustomerList && relationCustomerList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.type">Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('type')} />
                </th>
                <th className="hand" onClick={sort('title')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.title">Title</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('title')} />
                </th>
                <th className="hand" onClick={sort('reportType')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.reportType">Report Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reportType')} />
                </th>
                <th className="hand" onClick={sort('incidentType')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.incidentType">Incident Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('incidentType')} />
                </th>
                <th className="hand" onClick={sort('channel')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.channel">Channel</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('channel')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('updateDate')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.updateDate">Update Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('updateDate')} />
                </th>
                <th className="hand" onClick={sort('createDate')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.createDate">Create Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createDate')} />
                </th>
                <th className="hand" onClick={sort('contactRmsId')}>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.contactRmsId">Contact Rms Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contactRmsId')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.customer">Customer</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.relationCustomer.owner">Owner</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {relationCustomerList.map((relationCustomer, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/relation-customer/${relationCustomer.id}`} color="link" size="sm">
                      {relationCustomer.id}
                    </Button>
                  </td>
                  <td>{relationCustomer.type}</td>
                  <td>{relationCustomer.title}</td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.RelationReportMethod.${relationCustomer.reportType}`} />
                  </td>
                  <td>
                    <Translate
                      contentKey={`crawlerBackendApp.RelationIncidentMethod.${relationCustomer.incidentType}`}
                    />
                  </td>
                  <td>{relationCustomer.channel}</td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.RelationStatusMethod.${relationCustomer.status}`} />
                  </td>
                  <td>{relationCustomer.description}</td>
                  <td>
                    {relationCustomer.updateDate ? (
                      <TextFormat type="date" value={relationCustomer.updateDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {relationCustomer.createDate ? (
                      <TextFormat type="date" value={relationCustomer.createDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{relationCustomer.contactRmsId}</td>
                  <td>
                    {relationCustomer.customer ? (
                      <Link to={`/customer/${relationCustomer.customer.id}`}>{relationCustomer.customer.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {relationCustomer.owner ? (
                      <Link to={`/employee/${relationCustomer.owner.id}`}>{relationCustomer.owner.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/relation-customer/${relationCustomer.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/relation-customer/${relationCustomer.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/relation-customer/${relationCustomer.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.relationCustomer.home.notFound">
                No Relation Customers found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default RelationCustomer;
